import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1>Privacy Policy</h1>
      <p>Last updated: October 26, 2023</p>

      <h2>1. Introduction</h2>
      <p>Welcome to A/B testing. We are committed to protecting your privacy and handling your data in an open and transparent manner. This Privacy Policy outlines how we collect, use, store, and disclose your personal information when you use our services.</p>

      <h2>2. Information We Collect</h2>
      <p>We may collect information about you in a few ways:</p>
      <ul>
        <li><b>Personal Information:</b> Such as your name, email address, and Google account details when you log in via Google.</li>
        <li><b>Usage Data:</b> Information about how you access and use the service, including video IDs, rotation settings, and performance data (e.g., view counts) collected from YouTube API.</li>
        <li><b>Cookies:</b> We use cookies to manage your session and preferences.</li>
      </ul>

      <h2>3. How We Use Your Information</h2>
      <p>We use the collected information for various purposes:</p>
      <ul>
        <li>To provide and maintain our service, including managing your video rotations and A/B tests.</li>
        <li>To improve, personalize, and expand our service.</li>
        <li>To understand and analyze how you use our service.</li>
        <li>To communicate with you, including sending updates and support messages.</li>
        <li>To detect, prevent, and address technical issues.</li>
      </ul>

      <h2>4. Data Sharing and Disclosure</h2>
      <p>We do not share your personal information with third parties except in the following limited circumstances:</p>
      <ul>
        <li><b>With your consent:</b> We may share information when you give us permission to do so.</li>
        <li><b>For legal reasons:</b> If required to do so by law or in response to valid requests by public authorities.</li>
        <li><b>Service Providers:</b> We may employ third-party companies and individuals to facilitate our service (e.g., hosting, analytics), but they are obligated not to disclose or use your information for any other purpose.</li>
      </ul>

      <h2>5. Data Security</h2>
      <p>The security of your data is important to us, but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.</p>

      <h2>6. Your Data Protection Rights</h2>
      <p>Depending on your location, you may have the following rights regarding your personal data:</p>
      <ul>
        <li>The right to access, update or delete the information we have on you.</li>
        <li>The right of rectification.</li>
        <li>The right to object.</li>
        <li>The right of restriction.</li>
        <li>The right to data portability.</li>
        <li>The right to withdraw consent.</li>
      </ul>

      <h2>7. Changes to This Privacy Policy</h2>
      <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>
    </div>
  );
};

export default PrivacyPolicy;